<template>
    <Content >
        <primary-title class="mb-4">
            Meus {{ isBudgetLayout ? "orçamentos" : "pedidos" }}
        </primary-title>

        <ProgressBar
            v-if="purchase.progress && !isBudgetLayout"
            v-html="purchase.progress"
        ></ProgressBar>

        <card-account class="card" >
            <div class="card-header card-body-custom">
                <div class="card-header-left">
                    <p v-html="purchase.purchase.pedido_status"></p>
                    N°{{ purchase.purchase.id }}
                </div>
                <div class="card-header-right text-capitalize">

                    <button> <a @click.prevent="printPurchase()" >Imprimir</a></button>
                </div>
            </div>

            <div class="card-body" id="invoice-print">
                <div class="row">
                    <div class="col-md-12 invoice-purchase-product">
                        <PurchaseProducts
                            :products="purchase.items"
                            :purchase="purchase.purchase"
                        />
                    </div>
                    <div class="col-md-12 informations-purchase">
                        <PurchaseInformation :purchase="purchase" />
                    </div>
                </div>
            </div>
        </card-account>

        <div v-if="showObservations" class="row">
            <div class="col-md-12">
                <StyleInputGroup class="form-group" style="width: 100%;">
                    <label for="observacao_pedido">
                        <strong>
                            Informações complementares
                        </strong>
                    </label>
                    <textarea
                        name="observacao_pedido"
                        id="observacao_pedido"
                        required="required"
                        class="form-control"
                        :placeholder="placeholderObservation"
                        disabled
                    >
                    </textarea>
                </StyleInputGroup>
            </div>
        </div>
    </Content>
</template>

<script>
import {
    CPrimaryTitle,
    CSecondaryTitle
} from "../../../../components/Styles/Components/styled";
import ProgressBar from "../../../../components/ProgressBar";
import { CCardAccount } from "../../../../components/Styles/Template/styled";
import PurchaseProducts from "../PurchaseProducts";
import PurchaseInformation from "../PurchaseInformation";
import { mapState } from "vuex";
import { StyleInputGroup } from "../../../../components/Styles/Extends/styled";
import { Content } from "./style";

export default {
    name: "PurchaseCompleted",

    props: {
        purchase: {
            required: true
        }
    },
    components: {
        ProgressBar,
        PurchaseProducts,
        PurchaseInformation,
        StyleInputGroup,
        Content,
        "card-account": CCardAccount,
        "primary-title": CPrimaryTitle,
        "secondary-title": CSecondaryTitle
    },
    methods: {
        printPurchase()
        {
            const conteudo = document.getElementById("invoice-print").innerHTML;
            let style = `<style>
                img {
                    display: none;
                }
                .invoice-purchase-product {
                    margin-bottom: 25px;
                }
                .product-principal-purchase {
                    display:flex;
                    border-bottom: 1px solid #ddd;
                    margin: 0;
                    h3 {
                        margin-top: 0;
                        font-size: 0.7rem;
                        width: 400px;
                        font-weight: 500;
                    }

                    p {
                        position: unset;
                        margin: auto;
                        font-size: 0.7rem;
                        font-weight: 400;
                    }
                }
                .invoice-col-information{
                    display: flex;
                    justify-content: space-between;
                }
                .information-itens{
                    display:inline-block;
                    margin-bottom: 2rem;
                    h3 {
                        font-size: 18px;
                        margin: 0;
                        font-weight: 500;
                    }
                    p {
                        margin: 0.3rem 0 0;
                        font-size: 10px;
                        font-weight: 400;
                    }
                }
                .table-responsive {
                    display: inline-block;
                    font-size: 16px;
                    color: black;
                    width:500px;
                    tr {
                        font-weight: 500 !important;
                    }
                    th {
                        font-weight: 500;
                        padding-bottom: 1.5rem;
                        p {
                            font-size:12px;
                        }
                    }
                    td {
                        text-align: end;
                        padding-bottom: 1.5rem;
                    }
                    h3 {
                        margin-bottom: 0;
                    }
                    p {
                        margin-bottom: 0;
                    }
                }
            </style>
            `;

            const win = window.open('', 'new div', 'height=400,width=600');
            win.document.write('<html><head>');
            win.document.write('<link rel="stylesheet" type="text/css" href="style.js" media="screen" />')
            win.document.write('<link rel="stylesheet" type="text/css" href="../PurchaseItem/style.js" media="screen" />')
            win.document.write('<link rel="stylesheet" type="text/css" href="../PurchaseInformation/style.js" media="screen" />')
            win.document.write('<title> Pedido ' + this.purchase.purchase.id + '</title>');
            win.document.write(style);
            win.document.write('</head>');
            win.document.write('<body>');
            win.document.write(conteudo);
            win.document.write('<body></html>');
            win.print()
        }
    },
    computed: {
        ...mapState("company", ["company"]),
        isBudgetLayout() {
            return this.$root.$children[0].theme?.is_budget_layout ?? false;
        },
        showObservations() {
            return this?.company?.observation_on_purchase ?? false;
        },
        placeholderObservation() {
            return (
                this.purchase?.purchase?.obs ??
                `Nenhuma observação para este`
            );
        }
    }
};
</script>
